import { getFeature } from "../../../modules/features";
import { getViewport, SMALL_VIEWPORT } from "../../../modules/layout";

export default function miniBagEnabled(state) {
  return (
    getFeature(state, "stc-minibag-dropdown") &&
    getViewport(state) !== SMALL_VIEWPORT
  );
}
